import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Container.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
